
import { Options, Vue } from 'vue-class-component'
import { mapState, mapMutations } from 'vuex'
import COVERAPP from '@/utils/COVERAPP'

@Options({
    computed: {
        ...mapState(['userInfo', 'aid', 'textToNumber'])
    },
    data() {
        return {
            isApp: false,
            scrollText: [], // 滚动的文字
            showBtn: false,
        }
    },
    mounted() {
        this.isApp = COVERAPP.Attribute.isApp()
        this.$common.pageLoaded()
        this.$common.track('load', '进入福字选择页')
        this.getFu()
    },
    methods: {
        ...mapMutations(["SET_RANDOM", "SET_SELECTTEXT"]),
        getFu() {
            this.$request('/temporary/2023redpack/fu', {
                aid: this.aid,
                userinfo: this.userInfo,
            }, 'post').then((data: any) => {
                this.SET_SELECTTEXT({
                    text: data.text,
                    word: data.word,
                })
                this.setScroll(data.text, data.word)
            }).catch((err: any) => {
            })
        },
        goWrite() {
            this.$router.replace('/write')
        },
        getRandom(len = 49) {
            return Math.round(Math.random() * len); // 取0-49的随机数
        },
        getArrRandom(arr = []) {
            let r = this.getRandom(arr.length -1)
            return arr[r]
        },
        setScroll(text: string, word: string) {
            this.scrollText = [];
            for (let i = 0; i < 20; i++) {
                if (i == 19) {
                    let r = this.getArrRandom(this.textToNumber[text]);
                    this.scrollText.push(r)
                    this.startScroll()
                }
                else this.scrollText.push(this.getRandom());
            }

        },
        // 开始滚动
        startScroll() {
            // 创建一个动画实例
            this.$refs.scroll.animate([{
                transform: 'translateY(0)'
            }, {
                transform: 'translateY(' + -(this.scrollText.length - 1) * 24 + 'vw)'
            }], {
                duration: 1500,
                easing: 'ease-in-out',
                fill: 'forwards',
            })
            this.SET_RANDOM(this.scrollText[this.scrollText.length - 1])
            setTimeout(() => this.showBtn = true, 1500)
        },
    }
})
export default class Select2 extends Vue { }
